import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { EventLoggerService } from '@services/event-logger-service';

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'app-on-hold-popup',
  templateUrl: './on-hold-popup.html',
})
export class OnHoldPopupComponent implements OnChanges {
  @Input() showOnHoldPopup: boolean;
  @Input() showFeelingBetterPopup: boolean;
  @Input() showNotFeelingBetterPopup: boolean;
  @Input('holdData') onHoldData: any;
  @Input('ticketData') ticket: any;
  @Input('onHoldPopupResponse') onHoldPopupResponse: any;
  @Input('regimenClass') onHoldRegimenClass: any;
  @Input() userResponse: any;

  @Output() onHoldResponsePositive = new EventEmitter<void>();
  @Output() onHoldResponseNegative = new EventEmitter<void>();
  @Output() noOnHoldResponse = new EventEmitter<void>();

  llmSubCategory: string | null = null;

  constructor(
    private eventLogger: EventLoggerService,
    private router: Router,
  ) {}

  ngOnChanges(): void {
    const llmResp = this.ticket?.get('llmResponse');
    this.llmSubCategory = llmResp ? llmResp.subcategory : null;
  }

  onHoldResponseYes(): void {
    this.trackEvents('ON_HOLD_RESPONSE_YES', this.onHoldData.regimenId);
    this.onHoldResponsePositive.emit();
  }

  onHoldResponseNo(): void {
    this.trackEvents('ON_HOLD_RESPONSE_NO', this.onHoldData.regimenId);
    this.onHoldResponseNegative.emit();
  }

  onHoldResponseCancel(): void {
    this.trackEvents('ON_HOLD_RESPONSE_NOT_RESPONDED', this.onHoldData.regimenId);
    this.noOnHoldResponse.emit();
  }

  async viewInstruction(): Promise<void> {
    this.trackEvents('ON_HOLD_RESPONSE_VIEW_INSTRUCTIONS', this.onHoldData.regimenId);
    await this.router.navigate(
      ['/user'],
      { queryParams: { tab: 'regimen', class: this.onHoldRegimenClass ?? null } }
    );
    this.showFeelingBetterPopup = false;
  }

  openTicket(): void {
    if(!this.onHoldPopupResponse?.data?.redirectToTicket) {
      return;
    }
    const ticketId = this.onHoldPopupResponse?.data?.ticketId;
    this.trackEvents('ON_HOLD_RESPONSE_NOT_RESPONDED_TICKET_REDIRECT', ticketId);
    this.router.navigate([`/support/ticket/${ticketId}`]);
  }

  private trackEvents(name: string, regimenId: string): void {
    this.eventLogger.trackEvent(name, { regimenId });
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name }));
  }
}
